import React, { useEffect, useRef, useState } from 'react';
import warning from '../../../assets/svg/icons/Warning.svg';
import Dots from '../../../assets/images/Dots.svg';
import ActiveDots from '../../../assets/images/active-dots.svg';
import { Api } from '../../../api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { taskFeatureList } from '../../../utils/constants';
import toast from 'react-hot-toast';
import Loader from '../../../component/common/Loader';
import { ApiForRole } from './ApiForRole';
import { getLocalStorageItem,  isSuperAndSubAdmin } from '../../../utils/helper';

const ChallengePreview = ({ handlePageChange, setNewChallenge, newChallenge }) => {
  const location = useLocation();
  const state = location.state;
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const [deatils, setDetails] = useState({});
  const [tasks, setTasks] = useState([]);
  const [challengeImage, setChallengeImage] = useState(state?.imageUrl || '');

      useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const newChallengeParam = queryParams.get("newchallenge");
      setNewChallenge(newChallengeParam);
    }, [location.search]);

  const convertBackendTasks = (badge) => {

    if (!badge) return [];

    const backendTasks = badge || [];

    const groupedTasks = [];

    backendTasks.forEach((task) => {
      const matchedFeature = taskFeatureList.find((item) => item.backendName === task.feature);
      
      if (!matchedFeature) return;

      const group = matchedFeature.groubedBy;

      const subTask = {
        id: task._id,
        title: task.title,
        description: task.description,
        instruction: task.instruction,
        number_of_tries: task.number_of_tries,
        backend_name: task.feature,
        feature: matchedFeature.name,
        status: task.status,
        type_of_task: task.type_of_task,
        duration: task.duration,
        wellpoints: task.wellpoints
      };

      const existingGroup = groupedTasks.find((g) => g.grouped_by === group);
      if (existingGroup) {
        existingGroup.sub_tasks.push(subTask);
      } else {
        groupedTasks.push({
          id: group + '_' + Date.now(), 
          grouped_by: group,
          sub_tasks: [subTask]
        });
      }
    });

    return {
      tasks: groupedTasks
    };
  };
  const handleDelete = async (id) => {
    let updatedTasks;
setTasks((prev) => {
  updatedTasks = prev.filter((task) => task.id !== id);
  return updatedTasks;
});
    const convertToTotalMinutes = (hours, mins) => {
  const hoursNum = parseInt(hours) || 0;
  const minsNum = parseInt(mins) || 0;
  return (hoursNum * 60) + minsNum;
};
    const body = {
      challenge_id: state?._id
    };
        const flatTasks =
      updatedTasks.flatMap((group) =>
        group.sub_tasks.map((task) => ({
          // ...task,
          id: task.id !== 0 ? task.id : null,
          feature: task?.backend_name,
          isSubscription: task?.isSubscription === 1 ? true : task?.isSubscription === 0 ? false : '',
          duration: (task?.hours && task?.mins) ? convertToTotalMinutes(task.hours, task.mins) : 0,
          backend_name: task?.backend_name,
          connect_to_wearable: task?.connect_to_wearable === 1 ? true : task?.connect_to_wearable === 0 ? false : '',
          description: task?.description,
          days: task?.days,
          number_of_tries: task?.number_of_tries,
          title: task?.title,
          status: task?.status
        }))
      ) || [];
    if (flatTasks.length > 0) {
      body.tasks = flatTasks;
    }
    const response = await ApiForRole().addChallengesTask(body);
    if (response?.status === 200) {
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }

  };
  const TaskCard = ({ task, onDelete }) => {
    const [cardId, setCardId] = useState(null);
    const popupRef = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          setCardId(null);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [popupRef]);

    const handleButtonClick = () => {
      setCardId((prev) => (prev === task.id ? null : task.id)); 
    };

    return (
      <div
        className="gap-4 mt-4 p-3
               bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl"
      >
        {/* Card Header */}
        <div className="flex gap-4">
          <div className="flex-1">
            <div className="flex justify-between items-start mb-3">
              <h2 className="font-medium text-gray-800 flex items-center gap-2">
                {task.grouped_by}
                {/* <img id={task.id} src={warning} alt="Warning" className="w-6 h-6 cursor-pointer" />
                <Tooltip
                  anchorSelect={`#${task.id}`}
                  place="top"
                  content={task.msg}
                  className="max-w-xs break-words z-50"
                  style={{ zIndex: 9999 }}
                /> */}
              </h2>

              <div className="relative" ref={popupRef}>
                <button onClick={handleButtonClick}>
                  <img src={Dots} alt="Menu" className="w-6 h-6 block dark:hidden" />
                  <img src={ActiveDots} alt="Menu Active" className="w-6 h-6 hidden dark:block" />
                </button>

                {cardId === task.id && (
                  <div
                    className="w-35 z-50 bg-white dark:bg-shoorah-darkBgTabColor absolute top-4 right-0 mt-2 
                                       border-[1.5px] rounded-lg shadow-lg"
                  >
                    <div
                      className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-red-700 font-medium"
                      onClick={() => {
                        onDelete(task.id);
                        setCardId(null);
                      }}
                    >
                      Delete
                    </div>
                  </div>
                )}
              </div>
            </div>

            {task?.sub_tasks?.length > 0 &&
              task?.sub_tasks?.map((t, i) => (
                <div
                  key={i}
                  className="bg-[#F4F5F6] px-4 py-3 rounded-lg mb-2 border border-gray-100"
                >
                  <p className="font-medium text-gray-800">{t.title}</p>
                  <p className="text-sm text-gray-500">{t.description}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };
  const fetchList = async (id) => {
    try {
        setLoader(true);
      await ApiForRole().getSpecificChallenges(id).then((response) => {
        const responseData = response?.data || {};
        if (responseData) {
          const taskModify = convertBackendTasks(responseData?.tasks);
          setTasks(taskModify?.tasks || []);
          setDetails(responseData);
          if (responseData?.image) {
            setChallengeImage(responseData.image);
          }
        }
      });
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
        setLoader(false);
    }
  };

  useEffect(() => {
    if (state?._id) {
      fetchList(state?._id);
    }
  }, [state?._id]);


// console.log(deatils , "deatils ===>")
  const handleFinalSubmit = async (statusID) => {
    // console.log(statusID,"statusID ==> in handleFinalsubmit 1")
    try {
      setLoader(true);
      const body = {};
      // body.status = deatils?.status === 10 ? 11 : deatils?.status === 11 ? 11 : statusID;
      body.status = statusID === 0 || statusID === 1
    ? statusID
    : deatils?.status === 10 || deatils?.status === 11
    ? 11
    : statusID
      // body.status = statusID === 0 ? "draft" : "publish";
      body.challengeId = state?._id;
      const flatTasks =
        tasks?.flatMap((group) =>
          group.sub_tasks.map((task) => ({
            ...task,
            status: 'published',
            feature: task?.backend_name
          }))
        ) || [];

      if (flatTasks.length > 0) {
        body.tasks = flatTasks;
      } else {
        body.tasks = [];
      }
      // console.log(body, "body payload ==>")
      const response = await ApiForRole().updateChallengesStatus(body, state?._id);

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        navigate(userData?.slug ? `/${userData?.slug}/challenges` :'/challenges');
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };

  const formatDuration = (startDate, endDate) => {
    if (!startDate || !endDate) {
      return 'undefined';
    } 
    const start = new Date(startDate);
    const end = new Date(endDate);
    const getOrdinal = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    const startDay = getOrdinal(start.getDate());
    const endDay = getOrdinal(end.getDate());
    const startMonth = start.toLocaleDateString('en-GB', { month: 'short' });
    const endMonth = end.toLocaleDateString('en-GB', { month: 'short' });
    const year = end.getFullYear();
    return `${startDay} ${startMonth} - ${endDay} ${endMonth}, ${year}`;
  };
  const handleConvertChallenges = async (statusID) => {
    // console.log(statusID,"statusID ==> in handleConvertChallenges 1");
        const payload = {
      // ...deatils,
      status : 1,
      _id : null,
      // rewards : deatils.reward,
      rewards: deatils?.reward?.map((item) => ({
    // ...item,
    imageUrl: item.image,
    wellPoints : item.wellPoints,
    reward : item.reward,
    numberOfWinners : item.numberOfWinners,
    status : item.status,

  })),
  tasks: deatils?.tasks?.map((item) => ({
    title: item.title,
    description: item.description,
    instruction: item.instruction,
    feature: item.feature,
    number_of_tries: item.number_of_tries,
    days: item.days,
    isSubscription: item.isSubscription,
    type_of_task: item.type_of_task,
    status: item.status,
    connect_to_wearable: item.connect_to_wearable,
    duration: item.duration,
    deletedAt: item.deletedAt,
    subFeature: item.subFeature,
  })),
      title : deatils.title,
      description: deatils?.title,
    startDate: deatils?.startDate,
    endDate: deatils?.endDate,
    time: deatils?.time,
    imageUrl: deatils?.image,
    department : deatils?.department,
    email : deatils?.email,
    // tasks : deatils?.tasks,
    points : deatils?.points,
    }
    // console.log(payload, "final payload")
        try {
      setLoader(true);
      const response = await ApiForRole().convertChallengesFromTemplate(payload);

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        navigate(userData?.slug ? `/${userData?.slug}/challenges` :'/challenges');
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  }
  return (
    <div className="relative lg:mb-[45px]">
      {loader ? <Loader /> : null}
      <div className="flex justify-between items-center gap-2">
        <h3 className="font-medium text-xl">Preview</h3>
        <div className="ml-3 self-center">
          <button
            className="text-sm px-5 py-2 lg:rounded-2xl rounded-xl border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
            onClick={() => {
              handlePageChange('details');
            }}
          >
            Edit Challenge
          </button>
        </div>
      </div>
      <div className="max-w-[900px] p-[15px] mt-[15px] bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
        <div className="w-full p-[15px] bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
          {challengeImage && (
            <img
              src={challengeImage}
              alt="Challenge Cover"
              className="w-full h-[200px] object-cover rounded-xl mb-3"
            />
          )}
          <h3 className="font-[500] text-[16px]">{deatils?.title} </h3>
          {deatils?.reward?.[0] && (
            <div className="w-full p-[10px] flex items-center mt-2 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
              {deatils.reward[0].image && (
                <img
                  className="mr-2 h-[32px] w-[32px]"
                  src={deatils.reward[0].image}
                  alt=""
                />
              )}
              <p className="font-medium text-gray-800">
                {deatils.reward[0].reward
                  ? deatils.reward[0].reward
                  : deatils.reward[0].wellPoints > 0
                  ? `Wellpoints : ${deatils.reward[0].wellPoints}`
                  : ''}
              </p>
            </div>
          )}
          <div className="flex items-center mt-2 bg-[#F4F5F6] p-[10px]   dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <p className="font-medium text-gray-800">{`Duration - ${formatDuration(
              deatils?.startDate,
              deatils?.endDate
            )}`}</p>
          </div>
          <div className="bg-[#F4F5F6] p-[10px]  mt-2 dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <p className="font-medium text-gray-800">{deatils?.title}</p>
            <p className="text-sm text-gray-500 mt-2">{deatils?.description}</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1">
        <div className="grid grid-cols-1 max-w-[900px]">
          {tasks?.length > 0 &&
            tasks?.map((task, index) => (
              <TaskCard key={index} task={task} onDelete={handleDelete} />
            ))}
        </div>
      </div>
      <div className="flex justify-end mt-6">
        {isSuperAndSubAdmin() && (
          <div className="mr-3 self-center">
            <button
              type="button"
              onClick={() => {
                handleFinalSubmit(10);
              }}
              className="text-sm px-5 h-[40px] lg:rounded-2xl rounded-xl border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
            >
              Save as Template
            </button>
          </div>
        )}
        <button
          type="button"
          onClick={() => {
            if(deatils?.status === 10 || deatils?.status === 11){
              handleConvertChallenges(1);
            }
            else{
              handleFinalSubmit(1);
            }
          }}
          className="btn-primary btn-sm w-full sm:w-auto"
        >
          Publish Challenge
        </button>
      </div>
    </div>
  );
};

export default ChallengePreview;
